import api from "@dyl/apiClients/backendApi/api";

export default async function updateConfig(level_id, config_id, body) {
    const { data } = await api.put(`levels/${level_id}/configs/${config_id}`, body);
    return data;
}